// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const MyTasksBoardViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-mytasksboardview" */ "./MyTasksBoardView")).then((page)=>{
        return {
            default: page.MyTasksBoardView
        };
    });
export const LazyMyTasksBoardView = /*#__PURE__*/ lazy(MyTasksBoardViewLazyLoader);
